import * as React from "react";
import { WSErrorContainer } from "./WSErrorContainer";

export function withWSErrorContainer<T>(Component: (props: T) => JSX.Element | null) {
  return (props: T = {} as T) => (
    <WSErrorContainer>
      <Component {...props as any} />
    </WSErrorContainer>
  );
}
